/** @format */

import React, { useState, useRef } from "react";
import { ReactComponent as ResetIcon } from "images/svg/reset.svg";
import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
// import { CustomSelect } from "../../Leaderboard/styles/customStyles";
import DatePicker from "react-datepicker";

const WebinarFilterModal = ({
  isVisible,
  setVisible,
  setFilter,
  metadata,
  fellowType,
}) => {
  const modalRef = useRef(null);
  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState("");

  const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "423px",
    zIndex: 1001,
  };

  const handleReset = () => {
    setFilter(null);
    setVisible(false);
  };

  const handleApplyFilter = () => {
    if (!date?.start) {
      toast.warn("✔️ Please Select a Filter !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      const formattedDate = date.start.toISOString().split("T")[0];
      const formattedEndDate = date?.end
        ? date.end.toISOString().split("T")[0]
        : date.start.toISOString().split("T")[0];

      setFilter(
        `page=1&page_size=${metadata?.page_size}&current_program=${fellowType}&start_date=${formattedDate}&end_date=${formattedEndDate}`
      );
      setVisible(false);
    }
  };

  const isFilterSelected = () => {
    return date?.start ? true : false;
  };

  const isValidDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return true;

    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays <= 1;
  };

  //   const getMaxEndDate = (startDate) => {
  //     if (!startDate) return null;

  //     const maxDate = new Date(startDate);
  //     maxDate.setDate(maxDate.getDate() + 100);

  //     return maxDate;
  //   };

  const handleStartDateChange = (selectedDate) => {
    const newDate = { ...date, start: selectedDate };

    if (newDate.end && !isValidDateRange(selectedDate, newDate.end)) {
      newDate.end = null;
      setError("");
    }

    setDate(newDate);
  };

  const handleEndDateChange = (selectedDate) => {
    const newDate = { ...date, end: selectedDate };

    // if (!isValidDateRange(newDate.start, selectedDate)) {
    //   setError("Date range cannot exceed 2 days");
    //   return;
    // }

    setDate(newDate);
  };

  if (!isVisible) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        }}
      />
      <div className="filter-modal" style={modalStyle} ref={modalRef}>
        <div className="filter-modal-content">
          <h6>Filter</h6>
          {/* <div className="filter-section">
            <div className="filter-group">
              <label>Category</label>
              <CustomSelect
                value={selectedStates}
                onChange={setStates}
                options={StateOptions}
                placeholder="Filter by State"
              />
            </div>
          </div> */}

          <div className="d-flex">
            <div className="me-2">
              <label>Start</label>
              <div className="score-range-container calendar-input">
                <DatePicker
                  className="form-control bg-transparent w-full w-100"
                  selected={date.start}
                  onChange={handleStartDateChange}
                  placeholder="Start Date"
                  showIcon
                />
              </div>
            </div>

            <div className="ms-2">
              <label>End</label>
              <DatePicker
                className="form-control bg-transparent w-full w-100"
                selected={date.end}
                onChange={handleEndDateChange}
                placeholder="End Date"
                showIcon
                // minDate={date.start} // Prevent selecting dates before start date
                // maxDate={getMaxEndDate(date.start)} // Limit to max 2 days from start
                disabled={!date.start}
              />
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-group">
              <div className="score-range-container">
                <button
                  className="reset-filter table-reset"
                  onClick={() => handleReset()}
                >
                  <ResetIcon />
                  Reset Filter
                </button>
                <button
                  className="show-results-button"
                  disabled={isFilterSelected() ? false : true}
                  onClick={handleApplyFilter}
                >
                  Show Result
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebinarFilterModal;
